import React, { useEffect, useState } from "react";
import "./anggaran.css";
const REACT_APP_EXPRESS_API = process.env.REACT_APP_EXPRESS_API; 

const API_URL = `${REACT_APP_EXPRESS_API}/api/budget/history`;

const toIDR = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(Number(n || 0));

export default function HistoryBudgetsTable() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await fetch(API_URL, {
          method: "GET", 
          credentials: "include",
        });
        if (!res.ok) {
          throw new Error(`Gagal memuat data (${res.status})`);
        }
        const data = await res.json();

        // Pastikan selalu array
        const historyArray = Array.isArray(data.budgeting) ? data.budgeting : [];
        setHistory(historyArray);
      } catch (err) {
        console.error("Error fetching budget history:", err);
        setError(err.message || "Terjadi kesalahan saat memuat data");
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, []);
  return (
    <div className="history-container">
      <h3>📜 History Anggaran</h3>

      {loading && <p className="status">Memuat riwayat anggaran...</p>}
      {error && !loading && <p className="status error">{error}</p>}

      {!loading && !error && history.length === 0 && (
        <p className="status">Tidak ada data anggaran nonaktif.</p>
      )}

      {!loading && !error && history.length > 0 && (
        <div className="table-wrapper">
          <table className="history-table">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Budgeting</th>
                <th>Range Periode</th>
                <th>Makanan & Kebutuhan Rumah Tangga</th>
                <th>Transportasi</th>
                <th>Konektivitas</th>
                <th>Hiburan</th>
                <th>Tagihan & Lainnya</th>
              </tr>
            </thead>
            <tbody>
              {history.map((item, idx) => {
                const categories = item.categories_1 || {};
                return (
                  <tr key={item._id || idx}>
                    <td>{idx + 1}</td>
                    <td>
                      {item.period_name}
                    </td>
                    <td>
                      {`${new Date(item.startDate).toLocaleDateString("id-ID")} - ${new Date(item.endDate).toLocaleDateString("id-ID")}`}
                    </td>
                    <td>{toIDR(categories.makanan_kebutuhan_rumah_tangga)}</td>
                    <td>{toIDR(categories.transportasi)}</td>
                    <td>{toIDR(categories.konektivitas)}</td>
                    <td>{toIDR(categories.hiburan)}</td>
                    <td>{toIDR(categories.tagihan_lainnya)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}